import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from 'hooks/useAuth';

export const SignoutScreen = () => {
  const navigate = useNavigate();
  const { signout } = useAuth();

  const logout = async () => {
    await signout();
    navigate('/auth/signin');
  };

  useEffect(() => {
    logout();
  }, []);

  return null;
};
